import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { Transform } from 'class-transformer';
import { ExternalUserReportSimple } from './../../overrides/model/ExternalUserReportSimple.js';
import { UserRoleSimple } from './../../overrides/model/UserRoleSimple.js';
import { UserAbility } from './../../overrides/model/UserAbility.js';
import type { Constructor } from '@whispli/types';

export class __ExternalUser extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  /**
   * @deprecated For backwards-compatibility only. Use firstName
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private first_name!: string;

  @Expose({groups: ['client']})
  public get firstName() {
    return this.first_name
  }

  public set firstName(value) {
    this.first_name = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use lastName
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private last_name!: string;

  @Expose({groups: ['client']})
  public get lastName() {
    return this.last_name
  }

  public set lastName(value) {
    this.last_name = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly email!: string | null;
  /**
   * @deprecated For backwards-compatibility only. Use externalUserReportsCount
   */
  @Expose({groups:["server"]})
  @Type(() => Number)
  private external_user_whispers_count?: number;

  @Expose({groups: ['client']})
  public get externalUserReportsCount() {
    return this.external_user_whispers_count
  }

  public set externalUserReportsCount(value) {
    this.external_user_whispers_count = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use externalUserReports
   */
  @Type(() => ExternalUserReportSimple)
  @Expose({groups:["server"]})
  private external_user_whispers?: (ExternalUserReportSimple)[];

  @Expose({groups: ['client']})
  public get externalUserReports() {
    return this.external_user_whispers
  }

  public set externalUserReports(value) {
    this.external_user_whispers = value
  }

  @Type(() => UserRoleSimple)
  @Expose({ groups: ['client', 'server'] })
  public readonly roles?: (UserRoleSimple)[];
  @Type(() => UserAbility)
  @Expose({ groups: ['client', 'server'] })
  public readonly abilities?: (UserAbility)[];
  /**
   * @deprecated For backwards-compatibility only. Use forbiddenAbilities
   */
  @Type(() => UserAbility)
  @Expose({groups:["server"]})
  private forbidden_abilities?: (UserAbility)[];

  @Expose({groups: ['client']})
  public get forbiddenAbilities() {
    return this.forbidden_abilities
  }

  public set forbiddenAbilities(value) {
    this.forbidden_abilities = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use createdAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private created_at!: string | null;

  @Expose({groups: ['client']})
  public get createdAt() {
    return this.created_at
  }

  public set createdAt(value) {
    this.created_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use updatedAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private updated_at!: string | null;

  @Expose({groups: ['client']})
  public get updatedAt() {
    return this.updated_at
  }

  public set updatedAt(value) {
    this.updated_at = value
  }
}

interface OptionalAlias {
  externalUserReportsCount?: number | undefined;
  externalUserReports?: import("/builds/whispli/tenant-api-v2/whispli/packages/client/src/tenant/openapi/client/model/ExternalUserReportSimple").ExternalUserReportSimple[] | undefined;
  forbiddenAbilities?: import("/builds/whispli/tenant-api-v2/whispli/packages/client/src/tenant/openapi/overrides/model/UserAbility").UserAbility[] | undefined;
}
export type ExternalUser = Omit<__ExternalUser, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'first_name' | 'last_name' | 'external_user_whispers_count' | 'external_user_whispers' | 'forbidden_abilities' | 'created_at' | 'updated_at' | 'externalUserReportsCount' | 'externalUserReports' | 'forbiddenAbilities'> & OptionalAlias
export const ExternalUser = __ExternalUser as any as Constructor<ExternalUser>
